import Swal, {SweetAlertResult} from 'sweetalert2';
import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class MessageService {

    constructor(public toastr: ToastrService) {
    }

    success(message: string): void {
        this.toastr.success(message, 'Tudo OK!', {enableHtml: true});
    }

    error(message: string): void {
        this.toastr.error(message, 'Ops!', {enableHtml: true});
    }

    successMessage(message: string): Promise<SweetAlertResult> {
        return Swal.fire({
            title: 'Tudo OK!',
            text: message,
            icon: 'success'
        });
    }

    errorMessage(message: string): void {
        Swal.fire({
            title: 'Ops!',
            text: message,
            icon: 'error'
        });
    }

    warningMessage(message: string): void {
        Swal.fire({
            title: 'Ops!',
            text: message,
            icon: 'warning'
        });
    }

    invalidSessionMessage(): Promise<SweetAlertResult> {
        return Swal.fire({
            title: 'Faça login na aplicação!',
            text: 'O administrador alterou informações que impactaram na sua sessão. Para mais informações contate-o.',
            icon: 'warning',
            showConfirmButton: false,
            showCloseButton: false,
            showCancelButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: Swal.showLoading
        });
    }

    catchError = (error) =>
        error || error.length ? [].concat(error).forEach(er => this.errorMessage(er.mensagem)) :
            this.errorMessage('Ocorreu um erro desconhecido. Por favor, contate o administrador.')
}